import React, { useState, useEffect } from 'react';

const TestImageGallery = ({ testId }) => {
    const [images, setImages] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false); // Modal-Status
    const [currentIndex, setCurrentIndex] = useState(null); // Index des aktuellen Bildes

    // Bilder abrufen
    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await fetch(`/api/tests/test_images/${testId}`);
                const data = await response.json();
                if (!response.ok) {
                    throw new Error(data.message || 'Fehler beim Laden der Bilder');
                }
                if (data.images) {
                    setImages(data.images);
                } else {
                    setError(data.message);
                }
            } catch (err) {
                setError('Fehler beim Laden der Bilder.');
            } finally {
                setLoading(false);
            }
        };
        fetchImages();
    }, [testId]);

    // Bild im Modal öffnen
    const openModal = (index) => {
        setCurrentIndex(index); // Setze den Index des Bildes
        setIsModalOpen(true);
    };

    // Modal schließen
    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentIndex(null); // Zurücksetzen des aktuellen Index
    };

    // Navigieren zum nächsten Bild
    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length); // Nächstes Bild (rotierend)
    };

    // Navigieren zum vorherigen Bild
    const prevImage = () => {
        setCurrentIndex(
            (prevIndex) => (prevIndex - 1 + images.length) % images.length // Vorheriges Bild (rotierend)
        );
    };

    // Event-Listener für Tasteneingaben
    const handleKeyDown = (e) => {
        if (e.key === 'ArrowRight') {
            nextImage(); // Nächstes Bild bei rechter Pfeiltaste
        } else if (e.key === 'ArrowLeft') {
            prevImage(); // Vorheriges Bild bei linker Pfeiltaste
        }
    };

    // Effekt, um den Event-Listener für Tasteneingaben hinzuzufügen
    useEffect(() => {
        if (isModalOpen) {
            window.addEventListener('keydown', handleKeyDown);
        } else {
            window.removeEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown); // Aufräumen des Event-Listeners
        };
    }, [isModalOpen, currentIndex]);

    return (
        <>
            {loading ? (
                <p>Lade Bilder...</p>
            ) : error ? (
                <p>{error}</p>
            ) : (
                <div className="test-image-gallery">
                    <h3>Bilder:</h3>
                    <div className="gallery">
                        {images.map((image, index) => (
                            <div key={image.id} className="gallery-item">
                                <img
                                    src={image.image_url}
                                    alt="Testbild"
                                    onClick={() => openModal(index)} // Bild zum Vergrößern
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Modal für vergrößertes Bild */}
            {isModalOpen && images.length > 0 && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={closeModal}>×</span>
                        <div className="modal-wrapper">
                            <img src={images[currentIndex].image_url} alt="Vergrößertes Bild" className="modal-image" />
                        </div>
                        <div className="modal-navigation">
                            <button onClick={prevImage} className="nav-button prev">←</button>
                            <button onClick={nextImage} className="nav-button next">→</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TestImageGallery;
